// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/school_information.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_school } from "@buf/studyo_studyo-today-schools.bufbuild_es/studyo/today/schools/v1/resources/school_pb.js";
import { file_studyo_today_planners_v1_resources_user_summary } from "./user_summary_pb.js";

/**
 * Describes the file studyo/today/planners/v1/resources/school_information.proto.
 */
export const file_studyo_today_planners_v1_resources_school_information = /*@__PURE__*/
  fileDesc("CjtzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3NjaG9vbF9pbmZvcm1hdGlvbi5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyKfAgoRU2Nob29sSW5mb3JtYXRpb24SOQoGc2Nob29sGAEgASgLMikuc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzLlNjaG9vbBI/CgZvd25lcnMYAiADKAsyLy5zdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzLlVzZXJTdW1tYXJ5EhIKCmlzX3N0dWRlbnQYAyABKAgSEgoKaXNfdGVhY2hlchgEIAEoCBIdChVjb25uZWN0ZWRfcGxhbm5lcl9pZHMYBSADKAkSRwoOYWRtaW5pc3RyYXRvcnMYBiADKAsyLy5zdHVkeW8udG9kYXkucGxhbm5lcnMudjEucmVzb3VyY2VzLlVzZXJTdW1tYXJ5QiqqAidTdHVkeW8uVG9kYXkuUGxhbm5lcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_studyo_today_schools_v1_resources_school, file_studyo_today_planners_v1_resources_user_summary]);

/**
 * Describes the message studyo.today.planners.v1.resources.SchoolInformation.
 * Use `create(SchoolInformationSchema)` to create a new message.
 */
export const SchoolInformationSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_planners_v1_resources_school_information, 0);

